import React from "react";

import Details from "../../components/contests/details/details.component";
import RewardTiers from "../../components/contests/rewardTiers/rewardTiers.component";
import LeaderboardWrapper from "./wrappers/leaderboardWrapper";
import FeaturedChallengesWrapper from "./wrappers/featuredChallengesWrapper";
import CommentsWrapper from "./wrappers/commentsWrapper";
import Form from "../../components/contests/form/form.component";

import useContestSettings from "../../hooks/useContestSettings";

const ChallengeShow = () => {
  const {
    formObject,
    data: { winnerPublished },
    eligibility,
  } = useContestSettings();

  return (
    <>
      <div className="container">
        <div className="row mb-5">
          <div className="col-12">
            <Details />
            {eligibility && <RewardTiers />}
            {winnerPublished && <LeaderboardWrapper />}
            {formObject && <Form />}
          </div>
        </div>
      </div>
      <CommentsWrapper />
      <FeaturedChallengesWrapper />
    </>
  );
};

export default ChallengeShow;
